import { SizeType } from '@config/type'
import classNames from 'classnames'
import React, { HTMLProps } from 'react'

import { LoaderCircle } from '@components/loader-circle'

import { ButtonHtmlType, ButtonType, ButtonTypeEnum } from './button.config'

import styles from './button.module.css'

type ButtonProps = {
  className?: string
  appearance?: ButtonType
  sizeType?: SizeType
  fontSize?: SizeType
  flat?: boolean
  fullsize?: boolean
  loading?: boolean
  type?: ButtonHtmlType
} & HTMLProps<HTMLButtonElement>

export const Button: React.FC<ButtonProps> = React.memo((props) => {
  const {
    className,
    appearance = 'primary',
    sizeType = 'md',
    fontSize = 'md',
    fullsize = false,
    loading = false,
    flat = false,
    disabled,
    title,
    children,
    type = 'button',
    ...rest
  } = props
  const buttonCls = classNames(styles.container, className, {
    [styles.primary]: appearance === ButtonTypeEnum.PRIMARY,
    [styles.secondary]: appearance === ButtonTypeEnum.SECONDARY,
    [styles.inverse]: appearance === ButtonTypeEnum.INVERSE,
    [styles.inactive]: appearance === ButtonTypeEnum.INACTIVE,
    [styles.transparent]: appearance === ButtonTypeEnum.TRANSPARENT,
    [styles.sizeXxs]: sizeType === 'xxs',
    [styles.sizeXs]: sizeType === 'xs',
    [styles.sizeSm]: sizeType === 'sm',
    [styles.sizeMd]: sizeType === 'md',
    [styles.sizeLg]: sizeType === 'lg',
    [styles.sizeXl]: sizeType === 'xl',
    [styles.fontXxs]: fontSize === 'xxs',
    [styles.fontXs]: fontSize === 'xs',
    [styles.fontSm]: fontSize === 'sm',
    [styles.fontMd]: fontSize === 'md',
    [styles.fontLg]: fontSize === 'lg',
    [styles.fontXl]: fontSize === 'xl',
    [styles.flat]: flat === true,
    [styles.fullSize]: fullsize === true
  })
  return (
    <button
      type={type}
      disabled={disabled}
      title={title}
      className={buttonCls}
      {...rest}
    >
      {loading ? <LoaderCircle /> : props.children}
    </button>
  )
})
